"use client";

import { c as _c } from "react/compiler-runtime";
import React, { useState } from "react";
import { ApiDrop } from "@/generated/models/ObjectSerializer";
import Link from "next/link";
import UserCICAndLevel, { UserCICAndLevelSize } from "@/components/user/utils/UserCICAndLevel";
import { cicToType } from "@/helpers/Helpers";
import UserProfileTooltipWrapper from "@/components/utils/tooltip/UserProfileTooltipWrapper";
import { ArtistSubmissionBadge } from "@/components/waves/drops/ArtistSubmissionBadge";
import { ProfileWinnerBadge } from "@/components/waves/drops/ProfileWinnerBadge";
import { ArtistPreviewModal } from "@/components/waves/drops/ArtistPreviewModal";
interface SingleWaveDropAuthorProps {
  readonly drop: ApiDrop;
}
export const SingleWaveDropAuthor: React.FC<SingleWaveDropAuthorProps> = t0 => {
  const $ = _c(40);
  const {
    drop
  } = t0;
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalInitialTab, setModalInitialTab] = useState("active");
  const submissionCount = drop.author.active_main_stage_submission_ids?.length || 0;
  const hasSubmissions = submissionCount > 0;
  const winnerCount = drop.author.winner_main_stage_drop_ids?.length || 0;
  const isWinner = winnerCount > 0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = tab => {
      setModalInitialTab(tab);
      setIsModalOpen(true);
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const handleBadgeClick = t1;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      setIsModalOpen(false);
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const handleModalClose = t2;
  const t3 = `/${drop.author.handle}`;
  let t4;
  if ($[2] !== drop.author.pfp) {
    t4 = drop.author.pfp ? <img className="tw-size-10 tw-rounded-md tw-ring-1 tw-ring-inset tw-ring-white/10 tw-object-contain tw-bg-iron-900" src={drop.author.pfp} alt="User avatar" /> : <div className="tw-size-10 tw-rounded-md tw-ring-1 tw-ring-inset tw-ring-white/10 tw-bg-iron-800" />;
    $[2] = drop.author.pfp;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const t5 = drop.author.level;
  let t6;
  if ($[4] !== drop.author.cic) {
    t6 = cicToType(drop.author.cic);
    $[4] = drop.author.cic;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  let t7;
  if ($[6] !== drop.author.level || $[7] !== t6) {
    t7 = <UserCICAndLevel level={t5} cicType={t6} size={UserCICAndLevelSize.SMALL} />;
    $[6] = drop.author.level;
    $[7] = t6;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  const t8 = drop.author.handle ?? drop.author.id;
  let t9;
  if ($[9] !== drop.author.handle) {
    t9 = <span className="tw-text-md tw-font-medium tw-text-iron-200 desktop-hover:hover:tw-text-opacity-80">{drop.author.handle}</span>;
    $[9] = drop.author.handle;
    $[10] = t9;
  } else {
    t9 = $[10];
  }
  let t10;
  if ($[11] !== t8 || $[12] !== t9) {
    t10 = <UserProfileTooltipWrapper user={t8}>{t9}</UserProfileTooltipWrapper>;
    $[11] = t8;
    $[12] = t9;
    $[13] = t10;
  } else {
    t10 = $[13];
  }
  let t11;
  if ($[14] !== t10 || $[15] !== t7) {
    t11 = <div className="tw-flex tw-items-center tw-gap-x-2">{t7}{t10}</div>;
    $[14] = t10;
    $[15] = t7;
    $[16] = t11;
  } else {
    t11 = $[16];
  }
  let t12;
  if ($[17] !== t11 || $[18] !== t3 || $[19] !== t4) {
    t12 = <Link href={t3} className="tw-flex tw-items-center tw-gap-x-3 tw-no-underline desktop-hover:hover:tw-underline">{t4}{t11}</Link>;
    $[17] = t11;
    $[18] = t3;
    $[19] = t4;
    $[20] = t12;
  } else {
    t12 = $[20];
  }
  let t13;
  if ($[21] !== drop.id || $[22] !== isWinner || $[23] !== winnerCount) {
    t13 = isWinner && <ProfileWinnerBadge winCount={winnerCount} onBadgeClick={() => handleBadgeClick("winners")} tooltipId={`single-drop-winner-badge-${drop.id}`} />;
    $[21] = drop.id;
    $[22] = isWinner;
    $[23] = winnerCount;
    $[24] = t13;
  } else {
    t13 = $[24];
  }
  let t14;
  if ($[25] !== drop.id || $[26] !== hasSubmissions || $[27] !== submissionCount) {
    t14 = hasSubmissions && <ArtistSubmissionBadge submissionCount={submissionCount} onBadgeClick={() => handleBadgeClick("active")} tooltipId={`single-drop-badge-${drop.id}`} />;
    $[25] = drop.id;
    $[26] = hasSubmissions;
    $[27] = submissionCount;
    $[28] = t14;
  } else {
    t14 = $[28];
  }
  let t15;
  if ($[29] !== t12 || $[30] !== t13 || $[31] !== t14) {
    t15 = <div className="tw-flex tw-items-center tw-gap-x-3">{t12}{t13}{t14}</div>;
    $[29] = t12;
    $[30] = t13;
    $[31] = t14;
    $[32] = t15;
  } else {
    t15 = $[32];
  }
  let t16;
  if ($[33] !== drop.author || $[34] !== isModalOpen || $[35] !== modalInitialTab) {
    t16 = <ArtistPreviewModal isOpen={isModalOpen} onClose={handleModalClose} user={drop.author} initialTab={modalInitialTab} />;
    $[33] = drop.author;
    $[34] = isModalOpen;
    $[35] = modalInitialTab;
    $[36] = t16;
  } else {
    t16 = $[36];
  }
  let t17;
  if ($[37] !== t15 || $[38] !== t16) {
    t17 = <>{t15}{t16}</>;
    $[37] = t15;
    $[38] = t16;
    $[39] = t17;
  } else {
    t17 = $[39];
  }
  return t17;
};